import {
  REMOVE_ENDPOINT,
  UPLOAD_ENDPOINT,
  FILE_UPLOAD_ELEMENTS_IDS,
} from '../../consts';
import { initializeInstantFileUploaders } from '../../components/file_uploader';

const CONTAINER = '#account-dashboard-content';

const CSRF_TOKEN_ELEMENT = '#my-documents-csrf-token';

$(() => {
  initializeInstantFileUploaders({
    elementsIds: FILE_UPLOAD_ELEMENTS_IDS,
    container: CONTAINER,
    csrfTokenElement: CSRF_TOKEN_ELEMENT,
    uploadEndpoint: UPLOAD_ENDPOINT,
    removeEndpoint: REMOVE_ENDPOINT,
    isMakeAnOfferFile: false,
  });
});
